import { Component, OnInit, Input } from '@angular/core';

import { KpiByYear } from '@classes/simulation/kpi-by-year';
import { SimulationService } from '@services/simulation.service';
import { Kpi } from '@classes/simulation/kpi';

@Component({
    selector: 'app-gauges-list',
    templateUrl: './gauges-list.component.html',
    styleUrls: ['./gauges-list.component.scss']
})
export class GaugesListComponent implements OnInit {
    @Input() startIndex: number;
    @Input() stopIndex: number;
    @Input() years: KpiByYear[];
    @Input() selectedYear: number;

    constructor(
        private simulationSrv: SimulationService
    ) { }

    ngOnInit() {
    }

    setGaugeValue(kpis: Kpi[]): number {
        const filteredKpis = kpis.filter(k => k.isChartVisible === true);
        return filteredKpis[filteredKpis.length - 1].ratio.value;
    }

    onSelectYear(selectedYear: number) {
        this.simulationSrv.selectedYearChanged.next(selectedYear);
    }
}
